<template>
    <fullscreen-modal :open="open" @closed="close()">
        <template #modelcontent>
            <img v-if="imageUrl" :src="imageUrl" />
        </template>
    </fullscreen-modal>
</template>

<script>
import FullscreenModal from "./FullscreenModal";
export default {
    name: 'ImageModal',
    components: { FullscreenModal },
    props: {
        open: {
            type: Boolean,
            required: true
        },

        imageUrl: {
            type: String,
            required: false
        }
    },

    methods: {
        close() {
            this.$emit('closed', false);
        }
    }
}
</script>
